import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-upgrade-success',
  templateUrl: './upgrade-success.component.html',
  styleUrls: ['./upgrade-success.component.css']
})
export class UpgradeSuccessComponent implements OnInit {

  public newPlan: string;

  constructor(
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.newPlan = this.route.snapshot.queryParams.plan;
  }
}
